import React from 'react';

import { DealWithFarthestState } from '../../../utils';
import Stepper, { StepperItem } from '../dealStepper/Stepper';
import {
  getArrowDir,
  getPostSigningActiveStep,
  getPostSigningSteps,
  getStepBgColor,
} from '../utils';
import PostSigningStepContent from './PostSigningStepContent';

type Props = {
  deal: DealWithFarthestState;
};

const PostSigningDealStepper = ({ deal }: Props) => {
  const activeStep = getPostSigningActiveStep(deal);
  const steps = getPostSigningSteps(deal);
  const totalSteps = steps.length;

  const items: StepperItem[] = steps.map((step, index) => {
    const isCompleted = index < activeStep;
    const isCurrent = index === activeStep;
    const isFirst = index === 0;
    const isLast = index === totalSteps - 1;
    const dir = getArrowDir(index, totalSteps);
    const bgColor = getStepBgColor(index, activeStep, totalSteps);
    const nextBgColor = getStepBgColor(index + 1, activeStep, totalSteps);
    const tailColor = isLast ? bgColor : nextBgColor;

    return {
      key: step.label,
      dir,
      bgColor,
      tailColor,
      isFirst,
      isLast,
      isCurrent,
      content: (
        <PostSigningStepContent
          step={step}
          deal={deal}
          isCompleted={isCompleted}
          isCurrent={isCurrent}
          isLast={isLast}
        />
      ),
    };
  });

  return <Stepper items={items} animate={false} />;
};

export default PostSigningDealStepper;
